import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { LABEL } from '../../veriables';
import { TouchableButton, TouchableDiv } from '@components/common/Touchable';
import GiftCardDeleteIcon from './GiftCardDeleteIcon';

const GiftCardList = ({
  giftCards = [],
  onDeleteCard,
  serverAppTheme,
  currencySymbol = '$',
  showDelete = true,
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const cardsPerPage = 2;
  const totalPages = Math.ceil(giftCards.length / cardsPerPage);
  const showPagination = giftCards.length > cardsPerPage;

  const startIndex = currentPage * cardsPerPage;
  const endIndex = startIndex + cardsPerPage;
  const currentCards = giftCards.slice(startIndex, endIndex);

  useEffect(() => {
    if (currentCards.length === 0 && currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  }, [currentCards.length, currentPage]);

  const handlePrevious = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  if (giftCards.length === 0) {
    return null;
  }

  return (
    <div className="col-12 px-0">
      <div
        className="col-12 px-2 py-1"
        style={{
          backgroundColor: serverAppTheme?.stage_tab_button_selected,
          borderRadius: '8px',
          border: serverAppTheme?.popupBorder,
        }}
      >
        <div style={{ maxHeight: '95px', overflow: 'auto', marginBottom: showPagination ? '0.4rem' : '0' }}>
          {currentCards.map((card, index) => (
            <div
              key={card.accountNumber || index}
              className="d-flex justify-content-between align-items-center fs_16 fw-400"
              style={{
                backgroundColor: serverAppTheme?.inputBg,
                borderRadius: '4px',
                padding: '0.5rem 0.8rem',
                marginBottom: index < currentCards.length - 1 ? '0.4rem' : '0',
                color: serverAppTheme?.primary_text,
              }}
            >
              <div className="col-12 d-flex px-0">
                <div className="col-6 px-0 text-left">
                  {card.accountNumber || '****'}
                </div>
                <div className="col-6 px-0 text-right">
                  {currencySymbol}{(card.paymentAmount || 0).toFixed(2)}
                </div>
              </div>

              {showDelete && !card.fromTicket && (
                <TouchableDiv
                  onClick={() => onDeleteCard(card)}
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    cursor: 'pointer',
                    width: '28px',
                    height: '28px',
                    flexShrink: 0,
                    borderRadius: '4px',
                    backgroundColor: serverAppTheme?.mod_group_name_bg,
                    border: serverAppTheme?.select_border,
                  }}
                >
                  <GiftCardDeleteIcon
                    width={14}
                    height={16}
                  />
                </TouchableDiv>
              )}
            </div>
          ))}
        </div>

        {showPagination && (
          <div className="d-flex justify-content-between align-items-center px-1">
            <TouchableButton
              type="button"
              className={cn("btn-ripple rounded od-primary-btn-bg-color od-primary-btn-font-color")}
              style={{
                background: currentPage === 0
                  ? (serverAppTheme?.secondaryBtnDisabled || '#d3d3d3')
                  : (serverAppTheme?.secondaryBtn || '#2541A4'),
                color: currentPage === 0
                  ? (serverAppTheme?.btn_font_color_disabled || '#888')
                  : (serverAppTheme?.btn_font_color || '#fff'),
                border: 'none',
                borderRadius: '4px',
                fontSize: '1rem',
                fontWeight: '600',
                padding: '0.5rem 0.75rem',
                width: '70px',
                flexShrink: 0,
                opacity: currentPage === 0 ? 0.5 : 1,
                cursor: currentPage === 0 ? 'not-allowed' : 'pointer',
              }}
              onClick={handlePrevious}
              disabled={currentPage === 0}
              rippleEffect={true}
            >
              {LABEL().GS_BACK || 'BACK'}
            </TouchableButton>

            <div className="d-flex align-items-center justify-content-center" style={{ flex: 1, margin: '0 0.5rem' }}>
              {Array.from({ length: totalPages }).map((_, idx) => (
                <span
                  key={idx}
                  style={{
                    width: idx === currentPage ? '8px' : '6px',
                    height: idx === currentPage ? '8px' : '6px',
                    borderRadius: '50%',
                    display: 'inline-block',
                    backgroundColor: idx === currentPage
                      ? serverAppTheme?.secondaryBtn || '#2541A4'
                      : '#D1D5DB',
                    transition: 'all 0.3s ease',
                    marginLeft: idx > 0 ? '6px' : '0',
                  }}
                />
              ))}
            </div>

            <TouchableButton
              type="button"
              className={cn("btn-ripple rounded od-primary-btn-bg-color od-primary-btn-font-color")}
              style={{
                background: currentPage === totalPages - 1
                  ? (serverAppTheme?.secondaryBtnDisabled || '#d3d3d3')
                  : (serverAppTheme?.secondaryBtn || '#2541A4'),
                color: currentPage === totalPages - 1
                  ? (serverAppTheme?.btn_font_color_disabled || '#888')
                  : (serverAppTheme?.btn_font_color || '#fff'),
                border: 'none',
                borderRadius: '4px',
                fontSize: '1rem',
                fontWeight: '600',
                padding: '0.5rem 0.75rem',
                width: '70px',
                flexShrink: 0,
                opacity: currentPage === totalPages - 1 ? 0.5 : 1,
                cursor: currentPage === totalPages - 1 ? 'not-allowed' : 'pointer',
              }}
              onClick={handleNext}
              disabled={currentPage === totalPages - 1}
              rippleEffect={true}
            >
              {LABEL().GS_NEXT || 'NEXT'}
            </TouchableButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default GiftCardList;
